export const CONFIRMATION_METHOD_MOBILE_PIN = "mobile-pin";
export const CONFIRMATION_METHOD_EMAIL = "email";
export const CONFIRMATION_METHOD_SMS = "sms";
export const CONFIRMATION_METHOD_TWO_FA = "2fa";
export const CODE_INPUT_LENGTH_FOUR = 4;
export const CODE_INPUT_LENGTH_SIX = 6;
export const MINIMUM_PERIOD_TO_START_SAVING_PLAN = 14;
export const WAIT_PERIOD = 7;
export const MFA_SECRET_TRANSLATION_KEY = "mfaSecret";
export const LAST_POSSIBLE_DATE_FOR_FIRST= 23;
export const LAST_POSSIBLE_DATE_FOR_HALF= 8;